    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">

            <!--begin::Toolbar-->
            <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                    <!--begin::Page title-->
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <!--begin::Title-->
                     <div class="d-flex align-items-center">
                        <h1 class="page-heading">
                            <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_679_2720)">
                                <path d="M30.0547 0H5.94526C4.88421 0 4 0.820629 4 1.80538V18.7377C4 19.7224 4.88421 20.5431 5.94526 20.5431H30.0547C31.1158 20.5431 32 19.7224 32 18.7377V1.80538C32 0.793275 31.1158 0 30.0547 0ZM12.3116 1.86009C12.7832 1.86009 13.1368 2.2157 13.1368 2.62601C13.1368 3.06368 12.7537 3.39193 12.3116 3.39193C11.84 3.39193 11.4863 3.03633 11.4863 2.62601C11.4568 2.18834 11.84 1.86009 12.3116 1.86009ZM9.77684 1.86009C10.2484 1.86009 10.6021 2.2157 10.6021 2.62601C10.6021 3.06368 10.2189 3.39193 9.77684 3.39193C9.30526 3.39193 8.95158 3.03633 8.95158 2.62601C8.9221 2.18834 9.30526 1.86009 9.77684 1.86009ZM7.21263 1.86009C7.68421 1.86009 8.03789 2.2157 8.03789 2.62601C8.03789 3.06368 7.65474 3.39193 7.21263 3.39193C6.77053 3.39193 6.38737 3.03633 6.38737 2.62601C6.38737 2.18834 6.77053 1.86009 7.21263 1.86009ZM29.4947 18.0538C29.4947 18.1359 29.4358 18.1906 29.3474 18.1906H6.65263C6.56421 18.1906 6.50526 18.1359 6.50526 18.0538V5.27938H29.4947V18.0538Z" fill="#265D91"/>
                                <path d="M10.7766 12.8291H13.7829C14.1956 12.8291 14.5787 12.6376 14.785 12.282L15.8756 10.5587L19.0882 15.5646C19.2945 15.8928 19.6777 16.1116 20.0903 16.1116C20.5029 16.1116 20.8861 15.9202 21.0924 15.5646L22.8608 12.8018H25.1892C25.8377 12.8018 26.3682 12.3094 26.3682 11.7076C26.3682 11.1058 25.8377 10.6134 25.1892 10.6134H22.2124C21.7998 10.6134 21.4166 10.8049 21.2103 11.1605L20.1198 12.8838L16.9071 7.878C16.4945 7.22149 15.3156 7.22149 14.8734 7.878L13.105 10.6408H10.7766C10.1282 10.6408 9.59766 11.1332 9.59766 11.735C9.59766 12.3367 10.1282 12.8291 10.7766 12.8291Z" fill="#265D91"/>
                                </g>
                                <defs>
                                <filter id="filter0_d_679_2720" x="0" y="0" width="36" height="28.5431" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset dy="4"/>
                                <feGaussianBlur stdDeviation="2"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2720"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2720" result="shape"/>
                                </filter>
                                </defs>
                                </svg>
                                
                            
                            CRA
                        </h1>
                            <!--begin::Menu-->
                     </div>
                        <!--end::Title-->
                        <!--begin::Breadcrumb-->
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">
                                <a routerLink="/accueil" class="text-muted ">Accueil</a>
                              </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">CRA</li>
                            <!--end::Item-->
                        </ul>
                        <!--end::Breadcrumb-->
                    </div>
                    <!--end::Page title-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Toolbar container-->
            </div>
            <!--end::Toolbar-->
            <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card">
                        <!--begin::Card header-->

                      <div class="card-body tools">
                       <div class="title mb-10">
                        <h4>Activité normale</h4>
                       </div>     
                      </div>

                      <div class="toolsbar mb-5">
                        <a href="#" class="telecharger"> <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.38333 13.095H10.6167C10.9297 13.095 11.2396 13.0316 11.5287 12.9084C11.8179 12.7852 12.0806 12.6046 12.3019 12.377C12.5233 12.1494 12.6988 11.8791 12.8186 11.5817C12.9384 11.2843 13 10.9655 13 10.6436V7.30073C13 7.06431 12.9087 6.83757 12.7462 6.6704C12.5836 6.50322 12.3632 6.4093 12.1333 6.4093C11.9035 6.4093 11.683 6.50322 11.5205 6.6704C11.358 6.83757 11.2667 7.06431 11.2667 7.30073V10.6436C11.2667 10.8209 11.1982 10.991 11.0763 11.1163C10.9544 11.2417 10.7891 11.3122 10.6167 11.3122H2.38333C2.21094 11.3122 2.04561 11.2417 1.92371 11.1163C1.80182 10.991 1.73333 10.8209 1.73333 10.6436V7.30073C1.73333 7.06431 1.64202 6.83757 1.47949 6.6704C1.31696 6.50322 1.09652 6.4093 0.866667 6.4093C0.636812 6.4093 0.416372 6.50322 0.253841 6.6704C0.0913094 6.83757 0 7.06431 0 7.30073V10.6436C0 11.2937 0.2511 11.9173 0.698062 12.377C1.14502 12.8367 1.75123 13.095 2.38333 13.095Z" fill="#265D91"/>
                            <path d="M6.49962 0C6.26976 0 6.04932 0.0939179 5.88679 0.261093C5.72426 0.428268 5.63295 0.655007 5.63295 0.891429V6.5052L4.31562 5.27949C4.14524 5.12079 3.92055 5.03821 3.69097 5.04991C3.46139 5.06161 3.24574 5.16664 3.09145 5.34189C2.93716 5.51713 2.85687 5.74825 2.86825 5.98438C2.87963 6.22052 2.98174 6.44233 3.15212 6.60103L5.91895 9.17503C5.93628 9.19063 5.95362 9.20177 5.97095 9.21514C5.98828 9.22851 6.01212 9.24857 6.03378 9.26417C6.05972 9.28049 6.08648 9.29536 6.11395 9.30874L6.17895 9.34217C6.21011 9.35448 6.24194 9.3649 6.27428 9.37337L6.33495 9.3912C6.44362 9.41389 6.55561 9.41389 6.66428 9.3912L6.72495 9.37337C6.75729 9.36487 6.78912 9.35445 6.82028 9.34217L6.88528 9.30874C6.91276 9.29537 6.93952 9.28049 6.96545 9.26417C6.98712 9.24857 7.00662 9.23297 7.02828 9.21514C7.04995 9.19732 7.06295 9.19063 7.08028 9.17503L9.84712 6.60103C9.93148 6.52245 9.99997 6.42755 10.0487 6.32174C10.0974 6.21594 10.1254 6.1013 10.131 5.98438C10.1366 5.86746 10.1198 5.75054 10.0815 5.6403C10.0432 5.53006 9.98418 5.42866 9.90779 5.34189C9.83139 5.25511 9.73912 5.18467 9.63626 5.13457C9.53339 5.08447 9.42194 5.0557 9.30827 5.04991C9.19459 5.04411 9.08092 5.06141 8.97374 5.1008C8.86657 5.14019 8.76798 5.20091 8.68362 5.27949L7.36628 6.5052V0.891429C7.36628 0.655007 7.27497 0.428268 7.11244 0.261093C6.94991 0.0939179 6.72947 0 6.49962 0Z" fill="#265D91"/>
                            </svg>
                            Télécharger</a>
                        <a href="#" class="valider"> <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.9375 12.9919C6.16489 13.2181 6.49335 13.3688 6.82181 13.3688C7.15027 13.3688 7.47872 13.2181 7.73138 12.9919L18.621 2.16113C19.1263 1.65854 19.1263 0.879528 18.621 0.376941C18.1157 -0.125647 17.3324 -0.125647 16.8271 0.376941L6.82181 10.3282L2.17287 5.67924C1.66755 5.17665 0.884309 5.17665 0.378989 5.67924C-0.12633 6.18183 -0.12633 6.96084 0.378989 7.46343L5.9375 12.9919Z" fill="#265D91"/>
                            </svg>
                             Valider</a>
                      </div>




                      <div class="row">
                        <div class="col-lg-3">

                        </div>
                        <div class="col-lg-9">
                            <!--begin::Draggable heading-->
<h4 class="mb-3">Draggable Events</h4>
<!--end::Draggable heading-->

<!--begin::Events listing-->
<div id="external-events-list" class="d-flex flex-wrap">
    <div class="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event badge me-3 my-1">
        <div class="fc-event-main">Event 1</div>
    </div>
    <div class="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event badge me-3 my-1">
        <div class="fc-event-main">Event 2</div>
    </div>
    <div class="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event badge me-3 my-1">
        <div class="fc-event-main">Event 3</div>
    </div>
    <div class="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event badge me-3 my-1">
        <div class="fc-event-main">Event 4</div>
    </div>
    <div class="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event badge me-3 my-1">
        <div class="fc-event-main">Event 5</div>
    </div>
</div>
<!--end::Events listing-->

<!--begin::Checkbox-->
<div class="mt-2 my-5">
    <div class="form-check form-check-custom form-check-solid">
        <input class="form-check-input" type="checkbox" value="" id="drop-remove" />
        <label class="form-check-label" for="drop-remove">
            Remove event after drop
        </label>
    </div>
</div>
<!--end::Checkbox-->

<!--begin::Fullcalendar-->
<!-- <full-calendar [options]="calendarOptions"></full-calendar> -->
<div id="kt_docs_fullcalendar_populated"></div>
<!--end::Fullcalendar-->


                        </div>
                      </div>
                    </div>

                </div>
                <!--end::Content container-->
            </div>
            <!--begin::Content-->

            <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card pb-10 pt-10">
                     
                        <!--begin::Card header-->
                        <div class="d-flex flex-wrap my-1 header-grid align-items-center">
                            <div class="section_title">
                                <h1 class="section-heading my-0">Liste des CRA</h1>
                               </div>
                            <!--begin::Tab nav-->
                            <ul class="nav nav-pills me-5">
                                <li class="nav-item m-0">
                                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3" data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                        <i class="ki-duotone ki-element-plus fs-1">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                            <span class="path3"></span>
                                            <span class="path4"></span>
                                            <span class="path5"></span>
                                        </i>
                                    </a>
                                </li>
                                <li class="nav-item m-0">
                                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active" data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                        <i class="ki-duotone ki-row-horizontal fs-2">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>
                                    </a>
                                </li>
                            </ul>
                    
                         
                            <!--end::Wrapper-->
                        </div>
                       
                        
                        <!--end::Card header-->
                        <!--begin::Card body-->
                        <div class="card-body pt-0">
                        <div class="tab-content">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                 
                                                    <td class="actions">
                                                        <a href="#" class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
            
                                                         <svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91"/>
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91"/>
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91"/>
                                                    </svg>  </a>
                                                        <!--begin::Menu-->
                                                        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
                                                            <!--begin::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="/" class="menu-link px-3">Voir profil</a>
                                                            </div>
                                                            <!--end::Menu item-->
                                                            <!--begin::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="#" class="menu-link px-3">Archiver</a>
                                                            </div>
                                                            <!--end::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="suggestion" class="menu-link px-3">Voir suggestion</a>
                                                            </div>
                                                        </div>
                                                        <!--end::Menu-->
                                                    </td>                                   
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3"></div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">Poste 1  </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap">
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">3 ans et 6 mois</div>
                                                        <div class="fw-semibold text-gray-400">ANS.EXP</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">CDD</div>
                                                        <div class="fw-semibold text-gray-400">CONTRAT</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">Sousse</div>
                                                        <div class="fw-semibold text-gray-400">VILLE</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>
                                              
                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
            
                                                    <span class="badge actif"> <i class="fa-solid fa-circle"></i> Actif</span>
                                                </div>
                                                <div class="plus">
                                                    <a href="#">Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                 
                                                    <td class="actions">
                                                        <a href="#" class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
            
                                                         <svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91"/>
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91"/>
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91"/>
                                                    </svg>  </a>
                                                        <!--begin::Menu-->
                                                        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
                                                            <!--begin::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="/" class="menu-link px-3">Voir profil</a>
                                                            </div>
                                                            <!--end::Menu item-->
                                                            <!--begin::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="#" class="menu-link px-3">Postuler</a>
                                                            </div>
                                                            <!--end::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="#" class="menu-link px-3">Ne jamais voir cette offre</a>
                                                            </div>
                                                        </div>
                                                        <!--end::Menu-->
                                                    </td>                                   
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3"></div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">ESN 1  </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap">
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">$14,560</div>
                                                        <div class="fw-semibold text-gray-400">Année création</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">23</div>
                                                        <div class="fw-semibold text-gray-400">Nombre salarié</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">$236,400</div>
                                                        <div class="fw-semibold text-gray-400">Note</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>
                                              
                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
            
                                                    <span class="badge desactif"> <i class="fa-solid fa-circle"></i> Non actif</span>
                                                </div>
                                                <div class="plus">
                                                    <a href="#">Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="tools">
                                                 
                                                    <td class="actions">
                                                        <a href="#" class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
            
                                                         <svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91"/>
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91"/>
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91"/>
                                                    </svg>  </a>
                                                        <!--begin::Menu-->
                                                        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
                                                            <!--begin::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="/" class="menu-link px-3">Voir profil</a>
                                                            </div>
                                                            <!--end::Menu item-->
                                                            <!--begin::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="#" class="menu-link px-3">Postuler</a>
                                                            </div>
                                                            <!--end::Menu item-->
                                                            <div class="menu-item px-3">
                                                                <a href="#" class="menu-link px-3">Ne jamais voir cette offre</a>
                                                            </div>
                                                        </div>
                                                        <!--end::Menu-->
                                                    </td>                                   
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img src="assets/media//avatars/300-2.jpg" alt="image" />
                                                    <div class="bg-success position-absolute border border-4 border-body h-15px w-15px rounded-circle translate-middle start-100 top-100 ms-n3 mt-n3"></div>
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">ESN 1  </a>
                                                <!--end::Name-->
                                                <!--begin::Position-->
                                                <!--end::Position-->
                                                <!--begin::Info-->
                                                <div class="d-flex flex-center flex-wrap">
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">$14,560</div>
                                                        <div class="fw-semibold text-gray-400">Année création</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">23</div>
                                                        <div class="fw-semibold text-gray-400">Nombre salarié</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->
                                                    <div class="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                                                        <div class="fs-6 fw-bold text-gray-700">$236,400</div>
                                                        <div class="fw-semibold text-gray-400">Note</div>
                                                    </div>
                                                    <!--end::Stats-->
                                                </div>
                                              
                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="poste">
            
                                                    <span class="badge desactif"> <i class="fa-solid fa-circle"></i> Non actif</span>
                                                </div>
                                                <div class="plus">
                                                    <a href="#">Voir plus</a>
                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->
                                   
                                 
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <div class="card-body pt-3">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                                                <thead>
                                                    <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                        <th class="min-w-125px">nom</th>
                                                        <th class="min-w-125px">Client</th>
                                                        <th class="min-w-125px">DATE </th>
                                                        <th class="min-w-125px">Manager </th>
                                                        <th class="min-w-125px">status </th>
                                                        <th class="min-w-90px">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr>
                                                        <td>
                                                            <span class="name">Nom 1</span>
                                                          </td>
                                                        <td>
                                                          <span>Client </span>
                                                        </td>  
                                                        <td>
                                                           <span>21/07/2023</span>
                                                        </td>
                                                          <td><span>amine chouri</span></td>
                                                          <td>
                                                            <span class="badge actif"> <i class="fa-solid fa-circle"></i> Validé</span>
                                                          </td>
                                                         <td>
                                                            <div class="btns">
                                                               <a href="#" class="voir">Voir plus</a>
                                                                    
                                                            </div>
                                                         </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="name">Nom 1</span>
                                                          </td>
                                                        <td>
                                                          <span>Client </span>
                                                        </td>  
                                                        <td>
                                                           <span>21/07/2023</span>
                                                        </td>
                                                          <td><span>amine chouri</span></td>
                                                          <td>
                                                            <span class="badge actif"> <i class="fa-solid fa-circle"></i> Validé</span>
                                                          </td>
                                                         <td>
                                                            <div class="btns">
                                                               <a href="#" class="voir">Voir plus</a>
                                                                    
                                                            </div>
                                                         </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="name">Nom 1</span>
                                                          </td>
                                                        <td>
                                                          <span>Client </span>
                                                        </td>  
                                                        <td>
                                                           <span>21/07/2023</span>
                                                        </td>
                                                          <td><span>amine chouri</span></td>
                                                          <td>
                                                            <span class="badge actif"> <i class="fa-solid fa-circle"></i> Validé</span>
                                                          </td>
                                                         <td>
                                                            <div class="btns">
                                                               <a href="#" class="voir">Voir plus</a>
                                                                    
                                                            </div>
                                                         </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="name">Nom 1</span>
                                                          </td>
                                                        <td>
                                                          <span>Client </span>
                                                        </td>  
                                                        <td>
                                                           <span>21/07/2023</span>
                                                        </td>
                                                          <td><span>amine chouri</span></td>
                                                          <td>
                                                            <span class="badge actif"> <i class="fa-solid fa-circle"></i> Validé</span>
                                                          </td>
                                                         <td>
                                                            <div class="btns">
                                                               <a href="#" class="voir">Voir plus</a>
                                                                    
                                                            </div>
                                                         </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="name">Nom 1</span>
                                                          </td>
                                                        <td>
                                                          <span>Client </span>
                                                        </td>  
                                                        <td>
                                                           <span>21/07/2023</span>
                                                        </td>
                                                          <td><span>amine chouri</span></td>
                                                          <td>
                                                            <span class="badge actif"> <i class="fa-solid fa-circle"></i> Validé</span>
                                                          </td>
                                                         <td>
                                                            <div class="btns">
                                                               <a href="#" class="voir">Voir plus</a>
                                                                    
                                                            </div>
                                                         </td>
                                                    </tr>
                                                
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                </div>
                            </div>
                            <!--end::Tab pane-->
                        </div>
                            <!--end::Table-->
                        </div>
                        <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                    <!--begin::Modals-->
                    <!--begin::Modal - Customers - Add-->
              
                    <!--end::Modal - Customers - Add-->
                    <!--begin::Modal - Adjust Balance-->
                
                    <!--end::Modal - New Card-->
                    <!--end::Modals-->
                </div>
                <!--end::Content container-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
    <!--end:::Main-->
    </div>

    
        